import { ChildModel, ModelBase } from 'store/model-base';
import { LineUsage } from './line-usage';

export class UsageSummary extends ModelBase {
    public static storeName: string = 'usageSummary';

    public lineId: Id;
    public usageItems: LineUsage[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'usageItems',
            model: LineUsage
        }];
    }

    public get currentUsage(): LineUsage {
        this.usageItems.sort((usage1: LineUsage, usage2: LineUsage) => {
            const date1: Date = new Date(usage1.cycleStartDate);
            const date2: Date = new Date(usage2.cycleStartDate);

            return date2.getTime() - date1.getTime();
        });

        return this.usageItems[0];
    }
}
